import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { onBlankLayout } from 'store/slices/themeSlice';
import { useDispatch } from 'react-redux';

const AppRoute = ({
  component: Component,
  routeKey,
  blankLayout,
  ...props
}) => {
  const dispatch = useDispatch();
  const location = useLocation();
  const [reloadKey, setReloadKey] = useState(0);

  useEffect(() => {
    dispatch(onBlankLayout(!!blankLayout));
  }, [blankLayout, dispatch]);

  useEffect(() => {
    const urlParams = new URLSearchParams(location.search);
    if (urlParams.has('reload')) {
      setReloadKey((prev) => prev + 1);
      const newUrl = location.pathname;
      window.history.replaceState({}, '', newUrl);
    }
  }, [location.search, location.pathname]);

  return <Component key={reloadKey} {...props} />;
};

export default AppRoute;
